import {SiteEntity, siteSiteAssocsSelector, useGetSiteSiteAssocBySourceSiteQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {Grid} from "@mantine/core";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";
import { SiteSiteAssocDataTable } from "../../data-table/SiteSiteAssocDataTable/SiteSiteAssocDataTable";

export type SiteMileageProps = {
  site: SiteEntity,
}

export const SiteMileage = (props: SiteMileageProps) => {
  const {site} = props;

  const {regionId} = useApp();

  const selectSiteSiteAssocs = useMemo(() => {
    return siteSiteAssocsSelector();
  }, []);

  const {siteSiteAssocs, isLoading, isFetching} = useGetSiteSiteAssocBySourceSiteQuery({
    siteId: site.id,
    regionId: regionId,
  }, {
    selectFromResult: (result) => ({
      siteSiteAssocs: selectSiteSiteAssocs(result, {sourceSiteId: site.id}),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
    })
  });

  return (
    <Grid>
      <Grid.Col span={12}>
        <SiteSiteAssocDataTable
          withBorder
          records={siteSiteAssocs}
          fetching={isLoading || isFetching}
        />
      </Grid.Col>
    </Grid>
  )
}
